module.exports = __webpack_public_path__ + "media/images/desktop/GettyImages-950374614.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/desktop/GettyImages-950374614.jpg
// module id = 33
// module chunks = 0